import React from "react";

import SvgI78Logo from "assets/icons/I78Logo";

import { LogoContainer, LogoWrapper, LogoText } from "./styles";

type Props = {
  className?: any;
  text?: string;
};

const Logo = ({ className, text }: Props) => (
  <LogoContainer className={className}>
    <LogoWrapper withText={!!text}>
      <SvgI78Logo />
    </LogoWrapper>
    {text && <LogoText variant="h3">{text}</LogoText>}
  </LogoContainer>
);

export default Logo;
